
import { Box, AppBar, Tab, Tabs, Button } from "@material-ui/core";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { MapOcorrenciasContext } from "./MapaOcorrencias";
import { ResponsiveContainer, CartesianGrid, XAxis, YAxis, Legend, Tooltip, LineChart, Line/* BarChart, Bar, Cell*/ } from "recharts";
import { geraTotalOcorrenciasPorData, geraTotalOcorrenciasPorEspecie, geraTotalOcorrenciasPorMecanismo, geraTotalOcorrenciasPorResistencia} from "./businessLogic";
import './Graficos.css';
import FileSaver from "file-saver";
import { useCurrentPng } from "recharts-to-png";
import {GetApp} from "@material-ui/icons";
/*
const useStyles = makeStyles(theme => ({
    paper: {
        padding: 10,
        margin: 10,
        textAlign: 'left',
        overflow: 'auto',
        maxHeight: 'calc(100vh - 260px)',
        color: theme.palette.text.secondary,
        cursor: 'pointer',
    },
    formulario: {
        overflow: 'hidden'
    },
    formControl: {

    },
    button: {
        marginTop: '20px',
        marginBottom: '20px',
    },

}));

*/
export const Graficos: React.FC = () => {

    const context = useContext(MapOcorrenciasContext);

    //const tipos = useTSelector(state => state.tipodeareaReducer.tipodearea);

    const [tabs, setTabs] = useState<number>(1);

   // const [arrayCidades, setArrayCidades] = useState<any>([]);
    const [arrayDatas, setArrayDatas] = useState<any>([]);
    const [arrayDatasAcumuladas, setArrayDatasAcumuladas] = useState<any>([]);
    const [arrayEspecies, setArrayEspecies] = useState<any>([]);
    const [arrayMecanismos, setArrayMecanismos] = useState<any>([]);
    const [arrayResistencias, setArrayResistencias] = useState<any>([]);
    const [getPng, { ref }] = useCurrentPng();
  
    const handleDownload = useCallback(async (nome?:string) => {
        const png = await getPng();
        if (png) {
        FileSaver.saveAs(png, (nome? nome+'.png' :'grafico.png'));
        }
    }, [getPng]);

    useEffect(() => {
        //setArrayCidades(geraTotalOcorrenciasPorCidade(context.filterOcorrencias));
        setArrayDatas(geraTotalOcorrenciasPorData(context.filterOcorrencias));
        setArrayDatasAcumuladas(geraTotalOcorrenciasPorData(context.filterOcorrencias, true));
        setArrayEspecies(geraTotalOcorrenciasPorEspecie(context.filterOcorrencias));
        setArrayMecanismos(geraTotalOcorrenciasPorMecanismo(context.filterOcorrencias));
        setArrayResistencias(geraTotalOcorrenciasPorResistencia(context.filterOcorrencias));
    }, [context.filterOcorrencias]);
    return (
        <>
            <AppBar position="static" color='transparent'>
                <Tabs
                    value={tabs}
                    onChange={(event: React.ChangeEvent<{}>, newValue: number) => {
                        setTabs(newValue);
                    }}
                    aria-label="Opções para tipos de gráficos"
                >
                    <Tab label="Total por ano" value={1} />
                    <Tab label="Total por ano - acumulado" value={2} />
                    <Tab label="Total por espécie" value={3} />
                    <Tab label="Total por mecanismo" value={4} />
                    <Tab label="Total por resistência" value={5} />
                    
                </Tabs>
            </AppBar>
            {
                tabs === 1 ? (
                    <>
                    <Button onClick={() => handleDownload("Total_ano")}  size="medium">
                        <GetApp />
                    </Button>
                    
                    <Box  display='flex' height='400px'  >
                          
                        <ResponsiveContainer className="watermark" id="chart_1" width="99%" height="100%"  ref={ref}>
                            <LineChart
                                width={499}
                                data={arrayDatas}
                                margin={{
                                    top: 15,
                                    right: 10,
                                    left: 10,
                                    bottom: 15,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="ano"
                                />
                                <YAxis dataKey="total" />
                                <Tooltip />
                                <Legend />
                                <Line
                                    type="monotone"
                                    dataKey="total"
                                    name='Total de ocorrências'
                                    stroke="#8884d8"
                                    activeDot={{ r: 8 }}
                                />

                            </LineChart>
                        </ResponsiveContainer>
                    </Box>
                     </>

                ) : null
            }

            {
                tabs === 2 ? (
                <>
                    <Button onClick={() => handleDownload("Total_acumulado")}  size="medium">
                        <GetApp />
                    </Button>

                    <Box display='flex' height='400px'>
                        <ResponsiveContainer className="watermark"id="chart_2" width="99%" height="100%"  ref={ref}>
                            <LineChart
                                width={499}
                                data={arrayDatasAcumuladas}
                                margin={{
                                    top: 15,
                                    right: 10,
                                    left: 10,
                                    bottom: 15,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="ano"
                                />
                                <YAxis dataKey="total" />
                                <Tooltip />
                                <Legend />
                                <Line
                                    type="monotone"
                                    dataKey="total"
                                    name='Total acumulado de ocorrências'
                                    stroke="#055512"
                                    activeDot={{ r: 8 }}
                                />

                            </LineChart>
                        </ResponsiveContainer>
                    </Box>
                </>
                ) : null
            }
            {
                tabs === 3 ? (
                    <>
                    <Button onClick={() => handleDownload("Total_especie")}  size="medium">
                        <GetApp />
                    </Button>
                    <Box display='flex' height='400px'>
                    <ResponsiveContainer className="watermark"id="chart_2" width="99%" height="100%"  ref={ref}>
                        <LineChart
                            width={499}
                            data={arrayEspecies}
                            margin={{
                                top: 15,
                                right: 10,
                                left: 10,
                                bottom: 15,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                                dataKey="especie"
                            />
                            <YAxis dataKey="total" />
                            <Tooltip />
                            <Legend />
                            <Line
                                type="monotone"
                                dataKey="total"
                                name='Total de ocorrências por espécie'
                                stroke="#055512"
                                activeDot={{ r: 8 }}
                            />

                        </LineChart>
                    </ResponsiveContainer>
                </Box>
                </>
                ) : null
            }

            {
                tabs === 4 ? (
                    <>
                    <Button onClick={() => handleDownload("Total_mecanismo")}  size="medium">
                        <GetApp />
                    </Button>
                    <Box display='flex' height='400px'>
                    <ResponsiveContainer className="watermark"id="chart_4" width="99%" height="100%"  ref={ref}>
                        <LineChart
                            width={499}
                            data={arrayMecanismos}
                            margin={{
                                top: 15,
                                right: 10,
                                left: 10,
                                bottom: 15,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                                dataKey="mecanismo"
                            />
                            <YAxis dataKey="total" />
                            <Tooltip />
                            <Legend />
                            <Line
                                type="monotone"
                                dataKey="total"
                                name='Total de ocorrências por Mecanismo'
                                stroke="#055512"
                                activeDot={{ r: 8 }}
                            />

                        </LineChart>
                    </ResponsiveContainer>
                </Box>
                </>

                ) : null
            }

            {
                tabs === 5 ? (
                    <>
                    <Button onClick={() => handleDownload("Total_resistencia")}  size="medium">
                        <GetApp />
                    </Button>
                    <Box display='flex' height='400px'>
                    <ResponsiveContainer className="watermark"id="chart_5" width="99%" height="100%"  ref={ref}>
                        <LineChart
                            width={499}
                            data={arrayResistencias}
                            margin={{
                                top: 15,
                                right: 10,
                                left: 10,
                                bottom: 15,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                                dataKey="resistencia"
                            />
                            <YAxis dataKey="total" />
                            <Tooltip />
                            <Legend />
                            <Line
                                type="monotone"
                                dataKey="total"
                                name='Total de ocorrências por resistência'
                                stroke="#055512"
                                activeDot={{ r: 8 }}
                            />

                        </LineChart>
                    </ResponsiveContainer>
                </Box>
                </>

                ) : null
            }

        </>
    );
}